import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { TableContext, PopupContext } from "../../index";
import { Checkbox } from "../../view/Checkbox";
import NoteTooltip from "../../view/NoteTooltip";
import { deepCopy } from "../../utils";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import { POPUP_TYPES, getDeletePopup } from "../../view/popup/PopupContainer";
import {
    addNoteToValidationResult, deleteValidationResultNote,
    LoadRuleScriptsNConditions
} from "../ruleService"
import { ReactComponent as StickyNoteIcon } from "../validate/sticknote.svg";
import { styled } from '@mui/system';
// import Delete from '@mui/icons-material/Delete';
// import Add from '@mui/icons-material/Add';
// import Edit from '@mui/icons-material/Edit';
// import Details from '@mui/icons-material/Details';
// import ArrowUpward from '@mui/icons-material/ArrowUpward';
// import dots from "../../_resources/img/vdots.png";
import { MoreVertical, FileText, Edit, Trash2, Eye, Plus } from 'lucide-react';



const Severity = {
    HIGH: 'high',
    MEDIUM: 'medium',
    LOW: 'low'
}

const StyledNoteIcon = styled(StickyNoteIcon)(({ notecolor }) => ({
    width: 30,
    height: 30,
    color: notecolor || "#F9F290",
    cursor: "pointer"
}));

function AnalysisRow({ data, index, hiddenHeaders = [], userCapability }) {

    const history = useHistory();
    const { config, setConfig } = useContext(TableContext);

    //#region Set User Capabilities
    const [ruleDetailsCapability, setRuleDetailsCapability] = useState(-1);
    const [ruleOutputCapability, setRuleOutputCapability] = useState(-1);
    const [addNoteCapability, setAddNoteCapability] = useState(-1);
    const [deleteNoteCapability, setDeleteNoteCapability] = useState(-1);

    useEffect(() => {
        if (userCapability) {
            const ruleDetailsPermission = userCapability.find(item =>
                item.component === "analysisruledetails" && item.type === "field")?.permission;
            setRuleDetailsCapability(ruleDetailsPermission);
            const ruleOutputPermission = userCapability.find(item =>
                item.component === "analysisruleoutput" && item.type === "field")?.permission;
            setRuleOutputCapability(ruleOutputPermission);
            const addNotePermission = userCapability.find(item =>
                item.component === "analysisnote" && item.type === "field")?.permission;
            setAddNoteCapability(addNotePermission);
            const deleteNotePermission = userCapability.find(item =>
                item.component === "analysisdeletenote" && item.type === "field")?.permission;
            setDeleteNoteCapability(deleteNotePermission);
        }
        /* eslint-disable react-hooks/exhaustive-deps */
    }, []);
    //#endregion

    const getCircleType = () => {
        if (!data.severity) {
            return '';
        }

        switch (data.severity.toLowerCase()) {
            case Severity.HIGH:
                return "severity-high";
            case Severity.MEDIUM:
                return "severity-medium";
            case Severity.LOW:
                return "severity-low";
            default:
                return null;
        }
    }

    const getValidColor = () => {
        switch (data.valid) {
            case 1:
                return "valid-pass";
            case 0:
                return "valid-fail";
            case -1:
                return "valid-unknown";
            default:
                return null;
        }
    }

    const onCheckboxChange = () => {
        let selectedRows = deepCopy(config.selected);
        if (selectedRows.includes(data.id)) {
            selectedRows.splice(selectedRows.indexOf(data.id), 1);
        } else {
            selectedRows.push(data.id)
        }
        setConfig({ ...config, selected: selectedRows })
    }

    //Octopus DevTeam: Added -20230315
    // const useStyles = styled((theme) => ({
    //     img: {
    //         //margin: theme.spacing(0.2),
    //     },
    //     customImgStyle: {
    //         maxWidth: 300,
    //         fontSize: 13
    //     },
    //     customDeleteStyle: {
    //         maxWidth: 300,
    //         fontSize: 13
    //     }
    // }));

    // const classes = useStyles();

    //Octopus DevTeam: Added -20230315
    const [anchorEl, setAnchorEl] = React.useState(null);
    const { setPopup } = useContext(PopupContext);
    const [note, setNote] = useState(null);//to set the note in tooltip title
    const [noteColor, setNoteColor] = useState(null);
    const [icon, setIcon] = useState(false);
    //alert("validateTableRow "+ hiddenHeaders.length)

    useEffect(() => {
        if (data.note) {
            setIcon(true);
            setNote(data.note);
            setNoteColor(data.noteColor);
        }
        else {
            setIcon(false);
        }
        // //check if rules have notes
        // checkRuleNote(data.rulePk).then((res)=>{
        //      if(!res){
        //          setIcon(false);                
        //      }
        //      else{
        //          setIcon(true); 
        //          setNote(res);                
        //      }            
        //  });        
    }, []);


    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const confirmEventCreation = async (note, color) => {
        //addNoteToRule(data.rulePk,note)
        addNoteToValidationResult(data.id, note, color)
            .then((res) => {
                if (!res.note) {
                    setIcon(false);
                    setNote('');
                    setNoteColor('');
                }
                else {
                    setIcon(true);
                    setNote(note);
                    setNoteColor(color);
                }
                // window.location.reload();
            });
    };


    //Octopus DevTeam: Added -20230315
    const onAddNoteEvent = () => setPopup(
        {
            type: POPUP_TYPES.ADD_NOTE,
            note: note,
            color: noteColor,
            confirm: confirmEventCreation
        }
    );

    const onEditNoteEvent = () => setPopup(
        {
            type: POPUP_TYPES.EDIT_NOTE,
            editedNote: note,
            editedColor: noteColor,
            confirm: confirmEventCreation,

        },

    );

    const onDeleteRuleNoteEvent = () => {
        setPopup(
            getDeletePopup('Are you sure you want to delete this note?',
                'Delete Note',
                () => {
                    deleteValidationResultNote(data.id).then(res => {
                        if (!res) {
                            setIcon(false);
                            setNote('');
                            setNoteColor('');
                        }
                        else {
                            setIcon(true);
                            setNote(res);
                            setNoteColor(data.noteColor || '#F9F290');
                        }
                    });
                    //window.location.reload()
                },
                undefined,
                'Delete Note'
            )
        );

    };

    //Octopus DevTeam: Added -20230315
    // const onViewRuleOutput = () => setPopup(
    //     {
    //         type: POPUP_TYPES.VIEW_RULE_OUTPUT,
    //         output: data.output,
    //         // confirm: confirmEventCreation,
    //     },
    // );

    const onViewRuleOutput = async () => {
        try {
            const expectedOutput = await LoadRuleScriptsNConditions(data.rulePk);
            setPopup(
                {
                    type: POPUP_TYPES.VIEW_RULE_OUTPUT,
                    output: data.output,
                    expectedOutput: expectedOutput.data
                    // confirm: confirmEventCreation,
                });
        } catch (error) {
            console.error('Error:', error);
        }
    }


    const getHighlightColor = () => {
        const valid = data.valid;
        const previousValid = data.previousValid;

        // 0 is possible
        if (previousValid === undefined || previousValid === null) {
            return ''
        }

        if (previousValid === valid) {
            return ''
        }

        const { showChanges } = config;

        if (showChanges.passToFail) {
            if (previousValid === 1 && valid === 0) {
                return 'highlight-red';
            }
        }

        if (showChanges.failToPass) {
            if (previousValid === 0 && valid === 1) {
                return 'highlight-green';
            }
        }

        if (showChanges.passToUnknown) {
            if (previousValid === 1 && valid === -1) {
                return 'highlight-red';
            }
        }

        if (showChanges.unknownToPass) {
            if (previousValid === -1 && valid === 1) {
                return 'highlight-green';
            }
        }

        return `${index}_row`;
    }



    // const onClick = () => history.push('/add-rules/' + data.rulePk);

    return (
        <tr key={index}>
            <td>
                <Checkbox checked={config.selected.includes(data.id)} onClick={() => onCheckboxChange()} />
            </td>
            {hiddenHeaders.includes("NOTES") ? null : (
                <td>
                    {icon === true ? (
                        <NoteTooltip note={note} noteColor={noteColor}>
                            <StyledNoteIcon notecolor={noteColor} />
                        </NoteTooltip>
                    ) : (
                        <div className="oct_notes-placeholder-v2" />
                    )}
                </td>
            )}


            {hiddenHeaders.includes("RULE NAME") ? null : <td>{data.rule}</td>}
            {hiddenHeaders.includes("DESCRIPTION") ? null : <td>{data.details}</td>}
            {hiddenHeaders.includes("COMPLIANCE") ? null : <td>{data.compliance || '-'}</td>}
            {hiddenHeaders.includes("SECTION") ? null : <td>{data.sectionName || '-'}</td>}
            {hiddenHeaders.includes("SUBSECTION") ? null : <td>{data.subsectionName || '-'}</td>}
            {hiddenHeaders.includes("CREATED BY") ? null : (
                <td>
                    {data.user}
                </td>
            )}
            {hiddenHeaders.includes("SEVERITY") ? null : (
                <td>
                    <span className={`oct_severity-badge-v2 ${getCircleType()}`}>
                        {data.severity?.toUpperCase()}
                    </span>
                </td>
            )}
            {hiddenHeaders.includes("VALID") ? null : (
                <td className={getHighlightColor()}>
                    <span className={`oct_valid-badge-v2 ${getValidColor()}`}>
                        {data.valid === 1 ? 'PASS' : data.valid === -1 ? 'UNKNOWN' : 'FAIL'}
                    </span>
                </td>
            )}
            {hiddenHeaders.includes("GROUP") ? null : (
                <td>
                    {data.group}
                </td>
            )}
            {/* <td>
                <a className="btn oct_btn-tool-table" onClick={onClick}>
                    <i className="fas fa-ellipsis-v"></i>
                </a>
            </td> */}
            <td>
                <button className="oct_dropdown-trigger-v2" onClick={handleClick} >
                    <MoreVertical className="oct_icon" />
                </button>

                <Menu
                    className="oct_menu-v2"
                    id="dots-options"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClose}>

                    <MenuItem className="oct_menu-item-v2" onClick={ruleDetailsCapability === 0 ? null : () => {
                        handleClose();
                        history.push(`/add-rules/${data.rulePk}`);
                    }}
                        disabled={ruleDetailsCapability === 0 ? true : false}>
                        <FileText className="oct_icon" />Rule Details
                    </MenuItem>

                    <MenuItem className="oct_menu-item-v2" onClick={addNoteCapability === 0 ? null : () => {
                        handleClose();
                        icon ? onEditNoteEvent() : onAddNoteEvent();
                    }}
                        disabled={addNoteCapability === 0 ? true : false}>
                        {icon ? <Edit className="oct_icon" /> : <Plus className="oct_icon" />} {icon ? 'Edit Note' : 'Add Note'}
                    </MenuItem>

                    {icon ?
                        <MenuItem className="oct_menu-item-v2" onClick={deleteNoteCapability === 0 ? null : () => {
                            handleClose();
                            onDeleteRuleNoteEvent();
                        }}
                            disabled={deleteNoteCapability === 0 ? true : false}>
                            <Trash2 className="oct_icon" /> Delete Note
                        </MenuItem> : null
                    }

                    <MenuItem className="oct_menu-item-v2" onClick={ruleOutputCapability === 0 ? null : () => {
                        handleClose();
                        onViewRuleOutput();
                    }}
                        disabled={ruleOutputCapability === 0 ? true : false}>
                        <Eye className="oct_icon" /> View Rule Output
                    </MenuItem>

                </Menu>

            </td>
        </tr>
    )

}

function mapStateToProps(state) {
    const auth = state.auth;
    return {
        userCapability: auth.userCapability,
    }
}

export default connect(mapStateToProps)(AnalysisRow);
